export const ACTIVE_TRIP = {
  tripId: 'TRP-2026-8842',
  driverName: 'Ahmed Al Mansoori',
  vehicleNumber: 'DXB-T-4021',
  status: 'Active Transit',
  pickup: {
    label: 'ADNOC Refinery, Ruwais',
    emirate: 'Abu Dhabi',
    completedAt: '04:15 AM',
  },
  delivery: {
    label: 'Jebel Ali Power Station',
    emirate: 'Dubai',
    eta: '2:45 PM',
  },
  cargo: 'Gas Oil · 42,000 L',
  client: 'ADNOC',
  navigation: {
    remainingKm: 187,
    remainingMinutes: 142,
    currentRoad: 'E11 — Sheikh Maktoum Bin Rashid Rd',
    nextManeuver: 'Continue on E11 for 68 km',
  },
};

export const PRE_TRIP_CHECKLIST = [
  {
    id: 'tires',
    label: 'Tires & Pressure Inspection',
    description: 'All tires inflated to spec · no visible damage',
    icon: 'circle',
  },
  {
    id: 'brakes',
    label: 'Brakes Efficiency Check',
    description: 'Air brake system · parking brake hold test',
    icon: 'gauge',
  },
  {
    id: 'lights',
    label: 'Lights & Indicators Functional',
    description: 'Headlights, brake lights, turn signals, hazmat beacons',
    icon: 'lightbulb',
  },
  {
    id: 'hoses',
    label: 'Hoses & Valves (No leakage detected)',
    description: 'Hazardous liquid lines · manifold seals · drain valves',
    icon: 'droplets',
  },
  {
    id: 'safety_kit',
    label: 'Safety Kit & Hazmat Signage',
    description: 'Placards, spill kit, PPE, emergency triangles',
    icon: 'shield',
  },
  {
    id: 'extinguisher',
    label: 'Fire Extinguishers Pressure Check',
    description: 'Cab + trailer units · gauge in green zone',
    icon: 'flame',
  },
];

export const INITIAL_CHECKLIST_STATE = {
  tires: false,
  brakes: false,
  lights: false,
  hoses: false,
  safety_kit: false,
  extinguisher: false,
};
